import axios from 'axios'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Input, Checkbox, TimePicker, Switch, Button, message } from 'antd'
import { Backdrop, Slider } from '@mui/material'
import { createGeofenceInfo, updateGenofenceInfo } from 'src/@api/dashboard'
import { useRouter } from 'next/router'
import dayjs from 'dayjs'
import { androidLocalRefresh } from 'src/@api/android'
import { messageInfo } from 'src/components/Message'
import { useTranslation } from 'src/utils/i18n'

import Image from 'next/image'
import { useDispatch } from 'react-redux'
import { setCurrentTab } from 'src/store/apps/Common'
import { useDeviceScopedInit } from 'src/hooks/useDeviceScopedInit'
import { readLocalDeviceUdid } from 'src/utils/readAndroidLocalContext'

// 节流函数
function throttle(fn, delay = 1000) {
  var timer

  return function () {
    var _this = this
    var args = arguments
    if (timer) {
      return
    }
    timer = setTimeout(function () {
      fn.apply(_this, args)
      timer = null // 在delay后执行完fn之后清空timer，此时timer为假，throttle触发可以进入计时器
    }, delay)
  }
}

const SetGeofence = () => {
  const router = useRouter()
  const max = 1000
  const { query } = router
  const skipDeviceInitRef = useRef(true)

  const { t } = useTranslation('common')

  const [el, updateEl] = useState(null)
  const [name, updateName] = useState('')
  const [radius, updateRadius] = useState(Number(query.radius ?? 50))
  const [circle, updateCircle] = useState(null)
  const [point, updatePoint] = useState(query?.latlng?.split(',')?.map(v => Number(v)) ?? [])
  const [position, updatePosition] = useState(query?.name ?? '')
  const [showAlert, updateShowAlert] = useState(false)
  const [alertEmail, updateAlertEmail] = useState(!!query?.email_notification)
  const [saveDisabled, toggleSaveDisabled] = useState(true)
  const [startTime, updateStartTime] = useState(null)
  const [endTime, updateEndTime] = useState(null)
  const [saveStatus, updateSaveStatus] = useState(false)
  const [nameStatus, updateNameStatus] = useState(false)
  const [timeStatus, updateTimeStatus] = useState(false)
  const [week, updateWeek] = useState(query?.week?.split(',')?.map(Number) ?? [])
  const [timeData, updateTimeData] = useState({
    start: '',
    end: '',
    repeat: []
  })
  const weekList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((v, i) => ({
    label: `Every ${v}`,
    value: i + 1
  }))

  /**
   * 将小于 10 的数字前加 0
   * @param { number } num 需要加 0 的数字
   * @returns 转换为字符串的数字
   */
  const addZero = num => (num < 10 ? '0' : '') + num

  /**
   * 更改开始时间
   * @param { dayjs } time dayjs 类型的开始时间
   * @param { string } str hh:mm:ss 格式的字符串类型的开始时间
   */
  const changeStartTime = (time, str) => {
    updateStartTime(time)
    timeData.start = str
    updateTimeData(timeData)
    validTimeData()
  }

  /**
   * 更改结束时间
   * @param { dayjs } time dayjs 类型的结束时间
   * @param { string } str hh:mm:ss 格式的字符串类型的结束时间
   */
  const changeEndTime = (time, str) => {
    updateEndTime(time)
    timeData.end = str
    updateTimeData(timeData)
    validTimeData()
  }

  /**
   * 选择重复的星期几
   * @param { number[] } weekList 重复的星期列表
   */
  const changeWeek = weekList => {
    updateWeek(weekList)
    timeData.repeat = weekList
    updateTimeData(timeData)
    validTimeData()
  }

  /**
   * 校验时间数据
   */
  const validTimeData = () => {
    toggleSaveDisabled(!(timeData.start && timeData.end && timeData.repeat.length))
  }

  /**
   * 保存时间
   */
  const saveTime = () => {
    if (saveDisabled) return
    updateSaveStatus(true)
    updateShowAlert(false)
  }

  /**
   * 取消时间框
   */
  const cancelTime = () => {
    updateSaveStatus(timeData.end && timeData.start && timeData.repeat.length)
    updateShowAlert(false)
  }

  /**
   * 取消设置 Geofence 并返回 geofence 列表页
   */
  const cancelGeofence = () => {
    router.push('/android/local/geofence')
  }

  /**
   * 保存 Geofence 数据
   */
  const saveGeofence = throttle(() => {
    updateNameStatus(false)
    updateTimeStatus(false)
    if (!name.length || !point.length || point == '0') return

    // if (!saveStatus) return updateTimeStatus(true)

    const data = {
      device_id: readLocalDeviceUdid(),
      name: name,
      position: position,
      radius: radius,

      // start_time: `${addZero(startTime.$H)}:${addZero(startTime.$M)}`,
      // end_time: `${addZero(endTime.$H)}:${addZero(endTime.$M)}`,
      latlng: point.join(','),

      // week: week.join(','),
      email_notification: select1Key == 0 ? false : true,
      status: select2Key == 0 ? false : true
    }
    if (query.id) {
      data.id = query.id
      updateGenofenceInfo(data).then(({ code, msg }) => {
        if (code) messageInfo(msg, 1)
        else cancelGeofence()
      })
    } else {
      createGeofenceInfo(data).then(({ code, msg, data: result }) => {
        // 通知app数据更改
        androidLocalRefresh({
          device_id: readLocalDeviceUdid(),
          type: '41',
          geofence: [{ ...data, id: result.id }]
        })
        if (code) messageInfo(msg, 1)
        else cancelGeofence()
      })
    }
  }, 3000)

  /**
   * 获取当前坐标点
   * @returns { Promise<[number, number]> } 一个包含有当前经纬度的数组
   */
  const getPoint = async () => {
    if (point?.length === 2) {

      return point
    }

    // IP 定位
    return await getPointByIP()
  }

  const getPointByIP = async () => {
    try {
      const res = await fetch('https://ipapi.co/json/')
      const data = await res.json()
      console.log(112244, data)

      if (data.latitude && data.longitude) {
        return [data.latitude, data.longitude]
      }
    } catch (e) {
      console.error('IP 定位失败', e)
    }

    // 最终兜底（避免地图炸）
    return [0, 0]
  }

  /**
   * 获取当前位置信息
   * @param { number } latitude 纬度
   * @param { number } longitude 经度
   * @returns { Object } 地理位置信息
   */
  const getPosition = async (latitude = 0, longitude = 0) =>
    new Promise((success, fail) => {
      axios
        .get(`${process.env.NEXT_PUBLIC_LONGITUDE_KEY}?latitude=${latitude}&longitude=${longitude}`)
        .then(res => res.data)
        .then(res => (res ? success(res) : fail(res)))
    })

  /**
   * 更改半径
   * @param { number } radius 半径
   */
  const changeRadius = radius => {
    if (circle) circle.setRadius(radius).redraw()
    updateRadius(radius)
  }

  /**
   * 更改定位位置
   * @todo 根据用户输入的地址转换对应经纬度并定位到该地点
   */
  const changePosition = () => { }

  // 修改name写入input
  useEffect(() => {
    updateName(query.name ?? '')
  }, [])

  // 设备切换时重置围栏编辑表单并重新拉数
  useDeviceScopedInit(
    useCallback(() => {
      if (skipDeviceInitRef.current) {
        skipDeviceInitRef.current = false

        return
      }

      if (query.id) {
        router.push('/android/local/geofence')
      }
    }, [query.id, router])
  )

  useEffect(() => {
    // el 为地图容器元素 存在代表着地图已初始化
    if (el) return
    else
      getPoint()
        .then(point =>
          getPosition(...point)
            .then(res =>
              updatePosition(
                res.localityInfo.administrative
                  .map(v => v.name.replaceAll(' ', ''))
                  .reverse()
                  .join(' ')
              )
            )
            .then(res => point)
        )
        .then(point => {
          updatePoint(point)
          console.log(1122, point)

          // import('L').then(L => {
          const el = document.getElementById('map')
          const map = L.map(el, { maxZoom: 20, minZoom: 1 }).setView(point, 17)

          // 设置地图
          L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          }).addTo(map)

          // 范围圆圈
          const circle = L.circle(point, {
            color: 'skyblue',
            fillColor: 'skyblue',
            fillOpacity: '.5',
            radius: radius
          }).addTo(map)

          // 标记点
          L.marker(point, { draggable: true })
            .on('move', e => {
              point[0] = e.latlng.lat
              point[1] = e.latlng.lng
              circle.setLatLng(e.latlng).redraw()
              updatePoint(point)
            })
            .on('dragend', async e => {
              console.log(e, 'onchang')
              const res = await getPosition(...point)
              updatePosition(
                res.localityInfo.administrative
                  .map(v => v.name.replaceAll(' ', ''))
                  .reverse()
                  .join(' ')
              )
            })
            .addTo(map)

          updateEl(el)
          updateCircle(circle)

          // })
        })
  }, [])

  const select1Data = {
    0: 'Never notify',
    1: 'Only "Enters zone"'

    // 2: 'Only "Leaves zone"',
    // 3: 'Notify in any case'
  }
  const select2Data = {
    0: 'Restricted',
    1: 'Allowed'
  }
  const [select1Open, setSelect1Open] = useState(false)
  const [select2Open, setSelect2Open] = useState(false)
  const [select1Key, setSelect1Key] = useState(query?.email_notification == 'true' ? 1 : 0)
  const [select2Key, setSelect2Key] = useState(query?.status == 'true' ? 1 : 0)
  const [sliderValue, setSliderValue] = useState(0)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setCurrentTab(t('Geofence')))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  return (
    <>
      <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] h-full overflow-auto Blds:relative Blds:drop-shadow-none'>
        <div className='w-full pt-[15px] pb-[30px] px-[15px] Blds:w-[375px] Blds:absolute Blds:top-[12px] Blds:left-[16px] Blds:z-[999] Blds:bg-[#FFF] Blds:rounded-[10px] Blds:drop-shadow-[0_0_12px_rgba(0,0,0,0.13)]'>
          <p className='text-[16px] text-[#11141A] font-[600]'>{t('Add new fence zone')}</p>
          <div className='w-full mt-[13px]'>
            <p className='text-[13px] text-[#222222] Blds:text-[14px]'>
              1. {t('Tap on the map to add new fence zone')}
            </p>
            <p className='mt-[1px] text-[12px] text-[#8F98AF]'>{t('Intersections of fences are not allowed')}</p>
          </div>
          <div className='w-full mt-[13px]'>
            <div className='w-full flex justify-between'>
              <p className='text-[13px] text-[#222222] Blds:text-[14px]'>2. {t('Radius')}</p>
              <p className='text-[13px] text-[#222222]'>{radius} m</p>
            </div>
            <Slider
              aria-label='Temperature'
              value={radius}
              onChange={(_, newValue) => changeRadius(newValue)}
              valueLabelDisplay='auto'
              step={20}
              marks
              min={50}
              max={max} // shiftStep={30}
            />
          </div>
          <div className='w-full mt-[11px]'>
            <p className='text-[13px] text-[#222222] Blds:text-[14px]'>3. {t('Geo-fence name')}</p>
            <input
              className='mt-[18px] w-full h-[34px] px-[15px] rounded-[30px] bg-[#F4F5F6] outline-none text-[13px] text-[#222222]'
              value={name}
              onChange={e => updateName(e.target.value.trim())}
            />
            <p className='mt-[3px] text-[12px] text-[#8F98AF]'>
              {t('Geofence name must not be less than 3 and greater than 32 characters')}
            </p>
          </div>
          <div className='w-full mt-[28px]'>
            <p className='text-[13px] text-[#222222] Blds:text-[14px]'>4. {t('Notification')}</p>
            <div
              className='mt-[18px] w-full h-[34px] pl-[15px] pr-[13px] rounded-[30px] bg-[#F4F5F6] text-[13px] text-[#222222] flex justify-between items-center relative cursor-pointer'
              onClick={() => setSelect1Open(val => !val)}
            >
              {select1Data[select1Key]}
              <Image src='/images/geofence/drop-down.svg' width={15} height={16} alt='dorp-down'></Image>
              {select1Open && (
                <div className='w-full bg-[#FFF] rounded-[8px] shadow-[0_0_8px_rgba(0,0,0,0.15)] absolute top-[34px] left-0 overflow-hidden z-50'>
                  {Object.keys(select1Data).map(key => (
                    <div
                      key={key}
                      className={`${select1Key == key ? 'bg-[#F5F5F5]' : ''
                        } w-full h-[45px] pl-[18px] flex items-center`}
                      onClick={() => setSelect1Key(key)}
                    >
                      {select1Data[key]}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className='w-full mt-[28px]'>
            <p className='text-[13px] text-[#222222] Blds:text-[14px]'>5. {t('Geo-fence type')}</p>
            <div
              className='mt-[18px] w-full h-[34px] pl-[15px] pr-[13px] rounded-[30px] bg-[#F4F5F6] text-[13px] text-[#222222] flex justify-between items-center relative cursor-pointer'
              onClick={() => setSelect2Open(val => !val)}
            >
              {select2Data[select2Key]}
              <Image src='/images/geofence/drop-down.svg' width={15} height={16} alt='dorp-down'></Image>
              {select2Open && (
                <div className='w-full bg-[#FFF] rounded-[8px] shadow-[0_0_8px_rgba(0,0,0,0.15)] absolute top-[34px] left-0 overflow-hidden z-50'>
                  {Object.keys(select2Data).map(key => (
                    <div
                      key={key}
                      className={`${select2Key == key ? 'bg-[#F5F5F5]' : ''
                        } w-full h-[45px] pl-[18px] flex items-center`}
                      onClick={() => setSelect2Key(key)}
                    >
                      {select2Data[key]}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className='mt-[40px] w-full h-[34px] flex'>
            <div
              className='flex-1 border border-[#454CFF] rounded-[17px] text-[16px] text-[#454CFF] font-[600] flex justify-center items-center cursor-pointer'
              onClick={cancelGeofence}
            >
              {t('Cancel')}
            </div>
            <div className='w-[8px] h-full'></div>
            <div
              className={`${!name.length || !point.length || point == '0' ? 'opacity-70 cursor-not-allowed' : 'cursor-pointer'
                } flex-1 bg-[#FFCF55] rounded-[17px] text-[16px] text-[#1B1C2B] font-[600] flex justify-center items-center`}
              onClick={saveGeofence}
            >
              {query.id ? t('Save zone') : t('Add zone')}
            </div>
          </div>
        </div>
        {/* 地图 */}
        <div className='w-full h-[500px] overflow-hidden Blds:h-[calc(var(--vh)*100-90px)]'>
          <div id='map' className='w-full h-full'></div>
        </div>
      </div>
    </>

    //     <div className='h-[50rem] w-full flex row justify-between items-top bg-white p-10 sm:p-1 flex-row  sm:flex-col-reverse'>
    //   {/* 定时 */}
    //   <Backdrop open={showAlert} className='z-[2000]'>
    //     <div className='h-[24rem] w-[60rem] ml-[15%] bg-white p-10'>
    //       <div className='w-full h-[4rem] flex flex-row justify-start items-center'>
    //         <span className='mr-[1.5rem] w-[7rem]'>({t('Start Time')}): </span>
    //         <TimePicker
    //           format='HH:mm'
    //           onChange={changeStartTime}
    //           value={startTime}
    //           placeholder='Start Time'
    //           needConfirm={false}
    //           className='z-[2000]'
    //           popupClassName='z-[2001]'
    //         />
    //       </div>
    //       <div className='w-full h-[4rem] flex flex-row justify-start items-center'>
    //         <span className='mr-[1.5rem] w-[7rem]'>({t('End Time')}): </span>
    //         <TimePicker
    //           format='HH:mm'
    //           onChange={changeEndTime}
    //           value={endTime}
    //           placeholder='End Time'
    //           needConfirm={false}
    //           className='z-[2000]'
    //           popupClassName='z-[2001]'
    //         />
    //       </div>
    //       <div className='w-full h-[6rem] flex flex-row justify-start items-center'>
    //         <span className='mr-[2rem] w-[7rem]'>{t('Repeat')}: </span>
    //         <div className='w-full flex flex-row flex-wrap ml-2'>
    //           <Checkbox.Group options={weekList} value={week} onChange={changeWeek} />
    //         </div>
    //       </div>
    //       <div className='w-full h-[6rem] flex flex-row justify-center items-center'>
    //         <div
    //           onClick={cancelTime}
    //           className='h-[3rem] text-[skyblue] border border-[skyblue] rounded-3xl flex flex-row justify-center items-center mx-5 w-[8rem] hover:bg-[skyblue] hover:cursor-pointer hover:text-white'
    //         >
    //           {t('Cancel')}
    //         </div>
    //         <div
    //           onClick={saveTime}
    //           className={`h-[3rem] rounded-3xl flex flex-row justify-center items-center mx-5 w-[8rem] border-none text-white ${
    //             saveDisabled ? 'bg-[hsla(0,100%,0%,.1)] hover:cursor-not-allowed' : 'bg-[skyblue] hover:cursor-pointer'
    //           }`}
    //           disabled={saveDisabled}
    //         >
    //           {t('Save')}
    //         </div>
    //       </div>
    //     </div>
    //   </Backdrop>
    //   {/* 地图 */}
    //   <div className='w-[55%] h-[45rem] overflow-hidden sm:w-[100%] sm:mt-10'>
    //     <div id='map' className='w-full h-full'></div>
    //   </div>
    //   <div className='w-[40%] h-[45rem] flex flex-col justify-between items-center sm:w-[100%]'>
    //     <div className='h-[5rem] w-full'>
    //       <div className='text-[1.5rem] sm:text-[1rem] w-full'>{t('Name the Geofence')}</div>
    //       <Input className='h-[3rem]' value={name} onChange={e => updateName(e.target.value.trim())} />
    //       {nameStatus && <div className='text-[red] w-full text-[.8rem]'>{t('Please set a name for the geofence')}.</div>}
    //     </div>
    //     <div className='h-[5rem] w-full'>
    //       <div className='text-[1.5rem] sm:text-[1rem] w-full'>{t('Set Restricted Location')}</div>
    //       <Input className='h-[3rem]' value={position} onChange={changePosition} />
    //     </div>
    //     <div className='h-[7rem] w-full'>
    //       <div className='w-full flex justify-between align-middle'>
    //         <div className='text-[1.4rem] sm:text-[1rem]'>{t('Set Radius')}</div>
    //         <div className='text-[1.3rem] scale-75'>{radius}M</div>
    //       </div>
    //       <Slider step={3} max={max} min={50} value={radius} onChange={changeRadius} />
    //       <div className='w-full text-[1.1em] sm:text-[1rem] text-[gray] sm:mt-8'>
    //         {t('Radius of the geofence in meters')} ({max}m {t('max')}.)
    //       </div>
    //     </div>
    //     <div className='text-[1.4rem] sm:text-[1rem] w-full flex flex-row justify-between items-center flex-wrap sm:mt-8'>
    //       <div className='w-[50%] sm:text-[1rem]'>{t('Set Guard Time')}</div>
    //       <div
    //         onClick={() => updateShowAlert(true)}
    //         className='w-[50%] hover:cursor-pointer text-[.9rem] text-[skyblue] text-right'
    //       >
    //         {saveStatus ? `${timeData.start}-${timeData.end}` : `Set Now >`}
    //       </div>
    //       {timeStatus && <div className='text-[red] w-full text-[.8rem]'>{t('Please set the guarid time')}.</div>}
    //     </div>
    //     <div className='text-[1.3rem] w-full  flex flex-row justify-between items-center sm:mt-4'>
    //       <div className='w-[70%] text-[1rem]'>{t('Set Alerts via Notification Email')}</div>
    //       <Switch className='bg-[hsla(0,100%,0%,.2)]' checked={alertEmail} onChange={val => updateAlertEmail(val)} />
    //     </div>
    //     <div className='text-[1.5rem] w-full flex flex-row justify-center items-center sm:mt-8'>
    //       <Button
    //         onClick={saveGeofence}
    //         size='large'
    //         shape='round'
    //         className='mx-4 h-[3rem] w-[8rem] bg-[skyblue] text-white font-[600]'
    //       >
    //         {t('Save')}
    //       </Button>
    //       <Button
    //         onClick={cancelGeofence}
    //         size='large'
    //         shape='round'
    //         className='mx-4 h-[3rem] w-[8rem] text-[skyblue] border-[skyblue] font-[600]'
    //       >
    //         {t('Cancel')}
    //       </Button>
    //     </div>
    //   </div>
    // </div>
  )
}

export default SetGeofence


